'use client';
import React from 'react';
import MultiSelect from '@/components/ui/multi-select';
import { LazySection } from '@/components/ui/LazySection';

interface TechnologyFilterBarProps {
  platformOptions: string[];
  productOptions: string[];
  croOptions: string[];
  plexTypeOptions: string[];
  resolutionOptions: string[];
  throughputOptions: string[];
  selectedPlatforms: string[];
  setSelectedPlatforms: (v: string[]) => void;
  selectedProducts: string[];
  setSelectedProducts: (v: string[]) => void;
  selectedCROs: string[];
  setSelectedCROs: (v: string[]) => void;
  selectedPlexTypes: string[];
  setSelectedPlexTypes: (v: string[]) => void;
  selectedResolution: string[];
  setSelectedResolution: (v: string[]) => void;
  selectedThroughput: string[];
  setSelectedThroughput: (v: string[]) => void;
  platformLoading?: boolean;
  productLoading?: boolean;
  croLoading?: boolean;
}

export default function TechnologyFilterBar(props: TechnologyFilterBarProps) {
  return (
    <LazySection minHeight={60}>
      <div className="w-full mb-6">

        
        {/* Filter Grid - Two Rows of 3 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
          {/* Row 1 */}
          <MultiSelect
            options={props.platformOptions.map((platform) => ({ label: platform, value: platform }))}
            selected={props.selectedPlatforms}
            onChange={props.setSelectedPlatforms}
            placeholder="Platforms"
            disabled={props.platformLoading}
          />
          <MultiSelect
            options={props.productOptions.map((product) => ({ label: product, value: product }))}
            selected={props.selectedProducts}
            onChange={props.setSelectedProducts}
            placeholder="Products"
            disabled={props.productLoading}
          />
          <MultiSelect
            options={props.croOptions.map((cro) => ({ label: cro, value: cro }))}
            selected={props.selectedCROs}
            onChange={props.setSelectedCROs}
            placeholder="CROs"
            disabled={props.croLoading}
          />
          
          {/* Row 2 */}
          <MultiSelect
            options={props.plexTypeOptions.map((plex) => ({ label: plex, value: plex }))}
            selected={props.selectedPlexTypes}
            onChange={props.setSelectedPlexTypes}
            placeholder="Plex Types"
            disabled={false}
          />
          <MultiSelect
            options={props.resolutionOptions.map((res) => ({ label: res, value: res }))}
            selected={props.selectedResolution}
            onChange={props.setSelectedResolution}
            placeholder="Resolution"
            disabled={false}
          />
          <MultiSelect
            options={props.throughputOptions.map((thru) => ({ label: thru, value: thru }))}
            selected={props.selectedThroughput}
            onChange={props.setSelectedThroughput}
            placeholder="Throughput"
            disabled={false}
          />
        </div>
      </div>
    </LazySection>
  );
}